import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	CreateNovaAgentCategoryInput,
	CreateNovaAgentCategoryMutation,
} from './__generated__/CreateNovaAgentCategoryMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// `viewer.novaAgentCatalogue` (NovaStudioPage_Query) is a plain list, not a paginated
// connection, so there is no `@connection` key to RANGE_ADD into here. The caller (the shell
// page wiring) should refetch the catalogue in `onSuccess` to pick up the new category.
const mutation = graphql`
	mutation CreateNovaAgentCategoryMutation($input: CreateNovaAgentCategoryInput!) {
		createNovaAgentCategory(input: $input) {
			category {
				id
				name
				isUncategorised
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CreateNovaAgentCategoryInput>,
	onSuccess?: RelayOnCompleted<CreateNovaAgentCategoryMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<CreateNovaAgentCategoryMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
